/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Data-export admin list, editor, and copy modal.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {ButtonsModule} from 'ngx-bootstrap/buttons';
import {TimepickerModule} from 'ngx-bootstrap/timepicker';

import {AppSharedModule} from '../../common/app-shared.module';
import {AdminListModule} from '../../common/directives/admin-list.module';
import {AdnSelectModule} from '../../common/directives/adn-select/adn-select.module';
import {LineItemLabelsModule} from '../../line-item/line-item-labels.module';
import {DataExportCopyModalComponent} from './data-export-copy-modal.component';
import {DataExportEditPageComponent} from './data-export-edit-page.component';
import {DataExportListPageComponent} from './data-export-list-page.component';

const DATA_EXPORT = [
  DataExportCopyModalComponent,
  DataExportEditPageComponent,
  DataExportListPageComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    UIRouterModule,
    ButtonsModule,
    TimepickerModule,
    AdminListModule,
    AdnSelectModule,
    LineItemLabelsModule
  ],
  declarations: DATA_EXPORT,
  exports: DATA_EXPORT
})
export class DataExportModule {
}
